import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading.jsx';

/**
 * Reloads the latest stored activity snapshot (bypassing the API's short
 * in-memory cache), then returns home. This does NOT pull from Strava — that is
 * the job of the nightly cron / protected POST /api/refresh endpoint. Kept for
 * parity with the original page-refresh.php route.
 */
export default function RefreshPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    fetch('/api/activities?refresh=1')
      .catch(() => {})
      .finally(() => {
        if (!done) navigate('/', { replace: true });
      });
    return () => {
      done = true;
    };
  }, [navigate]);

  return <Loading label="Refreshing runs…" />;
}
